import axiosInstance from "../../../helpers/api";

export const getAllAnnouncements = (body) => {
    return axiosInstance.get('/admin/announcements', body);
};

export const editAnnouncement = (formData) => {
    return axiosInstance.post(`/admin/announcements/${formData.id}`, formData.formData);
};

export const createAnnouncement = (formData) => {
    return axiosInstance.post('/admin/announcements', formData);
};

export const deleteAnnouncement = (id) => {
    return axiosInstance.delete(`/admin/announcements/${id}`);
};

export const activateAnnouncement = (id) => {
    return axiosInstance.put(`/admin/announcements/activate/${id}`);
};

export const customNotifyPractice = (payload) => {
    return axiosInstance.post('/admin/asquera_practice/notify_practice_with_custom_message', payload);
};